import { render, staticRenderFns } from "./UnemploymentInsuranceFormPage.vue?vue&type=template&id=8d8203b8&"
import script from "./UnemploymentInsuranceFormPage.vue?vue&type=script&lang=js&"
export * from "./UnemploymentInsuranceFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports